import { render, staticRenderFns } from "./WinTheBid04.vue?vue&type=template&id=b5e1049c&scoped=true&"
import script from "./WinTheBid04.vue?vue&type=script&lang=js&"
export * from "./WinTheBid04.vue?vue&type=script&lang=js&"
import style0 from "./WinTheBid04.vue?vue&type=style&index=0&id=b5e1049c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e1049c",
  null
  
)

export default component.exports